import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";

const PREACHERS = "PREACHERS";
const PREACHER = "PREACHER";
const apiFetcher = new ApiFetcher();
export function* fetchPreachers(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `preachers?${queryString}`);
    yield put({
      type: sagaListSuccess(PREACHERS),
      data: res.data
    });
  } catch (e) {}
}

export function* searchPreachers(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `preachers?${queryString}`);
    yield put({
      type: sagaSearchSuccess(PREACHERS),
      data: res.data
    });
  } catch (e) {}
}

export function* fetchPreacher(action) {
  try {
    const res = yield call(apiFetcher.find, "preachers", action.id);
    yield put({
      type: sagaOneSuccess(PREACHER),
      data: res.data
    });
  } catch (e) {}
}

export function* createPreacher(action) {
  try {
    const res = yield call(apiFetcher.create, "preachers", action.data);

    yield put({
      type: sagaCreateSuccess(PREACHER),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Preacher created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* updatePreacher(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "preachers",
      action.data,
      action.id
    );
    yield put({
      type: sagaUpdateSuccess(PREACHER),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Preacher details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/sagas/preachers.js